import type { Theme, SxProps } from '@mui/material/styles';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

export type AuthLayoutProps = {
  sx?: SxProps<Theme>;
  children: React.ReactNode;
  header?: {
    sx?: SxProps<Theme>;
  };
};

export function AuthLayout({ sx, children }: AuthLayoutProps) {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', ...sx }}>
      {/* ----------------------------------------------------------------
       * Sol marka paneli (md+ görünür) — gradient + büyük logo + slogan + görsel
       * ---------------------------------------------------------------- */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          flex: '1 1 48%',
          position: 'sticky',
          top: 0,
          alignSelf: 'flex-start',
          height: '100vh',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 5,
          px: 6,
          overflow: 'hidden',
          color: 'common.white',
          background: 'linear-gradient(135deg, #1877F2 0%, #0C44AE 55%, #042174 100%)',
        }}
      >
        {/* dekoratif desen (düşük opaklık) */}
        <Box
          component="img"
          src="/assets/background/shape-square.svg"
          alt=""
          sx={{
            position: 'absolute',
            top: -80,
            right: -120,
            width: 520,
            opacity: 0.1,
            pointerEvents: 'none',
          }}
        />

        {/* büyük logo (beyaza çevrilmiş) */}
        <Box
          component="img"
          src="/assets/images/optimind_logo.png"
          alt="Optimind"
          sx={{
            width: 220,
            maxWidth: '60%',
            objectFit: 'contain',
            filter: 'brightness(0) invert(1)',
            zIndex: 1,
          }}
        />

        <Box sx={{ textAlign: 'center', maxWidth: 460, zIndex: 1 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1.5 }}>
            QR ile Akıllı Personel Devam Sistemi
          </Typography>
          <Typography sx={{ opacity: 0.85, lineHeight: 1.6 }}>
            Konum doğrulamalı giriş-çıkış, izin ve fazla mesai yönetimi — hepsi tek panelde.
          </Typography>
        </Box>

        {/* ürün görseli */}
        <Box
          component="img"
          src="/assets/illustrations/illustration-dashboard.webp"
          alt=""
          sx={{
            width: '100%',
            maxWidth: 480,
            borderRadius: 2,
            boxShadow: '0 24px 48px rgba(0,0,0,0.24)',
            zIndex: 1,
          }}
        />
      </Box>

      {/* ----------------------------------------------------------------
       * Sağ form paneli
       * ---------------------------------------------------------------- */}
      <Box
        sx={{
          flex: '1 1 52%',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          py: { xs: 6, md: 8 },
          px: { xs: 3, sm: 6 },
          bgcolor: 'background.default',
        }}
      >
        {/* mobilde logo (sol panel gizliyken) */}
        <Box
          component="img"
          src="/assets/images/optimind_logo.png"
          alt="Optimind"
          sx={{
            display: { xs: 'block', md: 'none' },
            width: 140,
            objectFit: 'contain',
            mb: 5,
          }}
        />

        <Box sx={{ width: 1, maxWidth: 420 }}>{children}</Box>
      </Box>
    </Box>
  );
}
